export const SETTINGS_HEADER_TABLE = {
    trafficSource: 'trafficSource',
    trafficSourceParameters: 'trafficSourceParameters',
    vendor: 'vendor',
    buyer: 'buyer',
    buyerInvitations: 'buyerInvitations',
    vendorInvitations: 'vendorInvitations',
    destination: 'destination',
    campaignIncludeDestination: 'campaignIncludeDestination',
    destinationsGroup: 'destinationsGroup',
    destinationGroupParameters: 'destinationsGroupParameters',
    availableDestinationGroup: 'availableDestinationGroup',
    availableNumbersInNumberPool: 'availableNumbersInNumberPool',
    blockNumber: 'blockNumber',
    numberPool: 'numberPool',
    numberInPool: 'numberInPool',
    manageNumber: 'manageNumber',
    campaigns: 'campaigns',
    globalOffers: 'globalOffers',
    offers: 'offers',
    requests: 'requests',
    forwardCallsTo: 'forwardCallsTo',
    forwardCallsToByRevenue: 'forwardCallsToByRevenue',
    campaignTrackingNumber: 'campaignTrackingNumbers',
    campaignAvailableTrackingNumber: 'campaignAvailableTrackingNumber',
    campaignAvailableNumberPools: 'campaignAvailableNumberPools',
    campaignAvailableDestination: 'campaignAvailableDestination',
    campaignAvailableGroupDestination: 'campaignAvailableGroupDestination',
    campaignAccess: 'campaignAccess',
    campaignAddUsers: 'campaignAddUsers',
    campaignEnrichmentUrls: 'campaignEnrichmentUrls',
    campaignOfferRequests: 'campaignOfferRequests',
    loginSecurity: 'loginSecurity',
    apiAccessToken: 'apiAccessToken',
    paymentHistory: 'paymentHistory',
    callLog: 'callLog',
    aggregated: 'aggregated',
    workspaceActivity: 'workspaceActivity',
    reporting: 'reporting',
    callFlows: 'callFlows',
    voipShield: 'voipShield',
    tcpaShield: 'tcpaShield',
    blockedCarrier: 'blockedCarrier',
    customParameters: 'customParameters',
    leads: 'leads',
    dispute: 'disputes',
    callFlowAvailableDestinations: 'callFlowAvailableDestinations',
    callFlowAvailableGroups: 'callFlowAvailableGroups',
    detailGoogleIntegrationTrafficSource: 'detailGoogleIntegrationTrafficSource',
    detailFacebookIntegrationTrafficSource: 'detailFacebookIntegrationTrafficSource',
    detailIncomingWebhookIntegration: 'detailIncomingWebhookIntegration',
    detailOutgoingWebhookIntegration: 'detailOutgoingWebhookIntegration',
    detailLogsOutgoingWebhookIntegration: 'detailLogsOutgoingWebhookIntegration',
    detailTrafficSourceEventsLog: 'detailTrafficSourceEventsLog',
    byocIntegrationNumbers: 'byocIntegrationNumbers',
    byocIntegrationCarriers: 'byocIntegrationCarriers',
    googleConversation: 'googleConversation',
    facebookEvents: 'facebookEvents',
    detailNumberPoolTrafficSources: 'detailNumberPoolTrafficSources',
    detailNumberPoolAvailableTrafficSources: 'detailNumberPoolAvailableTrafficSources',
    pingLog: 'pingLog',
    workspaceUsers: 'workspaceUsers',
    numberPoolTrafficSources: 'numberPoolTrafficSources',
    numberPoolAttachTrafficSources: 'numberPoolAttachTrafficSources',
    rates: 'rates',
    rtbLog: 'rtbLog',
}
